import { render } from "./companies.vue?vue&type=template&id=65ae8942&ts=true"
import script from "./companies.vue?vue&type=script&lang=ts"
export * from "./companies.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__